import { axiosInstance } from "../../config/axios";
import { AxiosError } from "axios";
import { useMutation } from "react-query";
import { BaseResponse } from "../_types";

export interface ProductDetailRequest {
  id: number;
}

export interface ProductDetailData {
  productCode: string;
  productName: string;
  productGroupId: number;
  salePrice: number;
  buyingPrice?: number | null;
  taxRateId: number;
  unit: number;
  merchantId?: number;
  currencyCode?: string;
  isOpenPrice: boolean;
  barcode?: string | null;
  id: number;
  status: "BLOCKED" | "ACTIVE" | "PASSIVE";
  systemDate: string;
  createDate: string;
  createUserId: number;
  updateDate?: string | null;
  updateUserId: number;
  deleteDate?: string | null;
  deleteUserId: number;
}

export type ProductDetailResponse = BaseResponse<ProductDetailData>;

async function getProductDetail(
  data: ProductDetailRequest
): Promise<ProductDetailResponse> {
  try {
    return (await axiosInstance.get(`/Product/GetProduct?id=${data.id}`)).data;
  } catch (ex) {
    throw ((ex as AxiosError).response?.data as any).error;
  }
}

export function useProductDetail() {
  return useMutation<ProductDetailResponse, Error, ProductDetailRequest>(
    (variables) => getProductDetail(variables)
  );
}